import { lookupPin } from '../lib/api';
import { loadCleengScript, initializeCleengWidget } from '../lib/cleeng';
import { setPinCookie, setDeviceTypeCookie } from '../lib/cookies';

const pinForm = document.getElementById('pin-form') as HTMLDivElement;
const loadingDiv = document.getElementById('loading') as HTMLDivElement;
const widgetDiv = document.getElementById('cleeng-widget') as HTMLDivElement;
const form = document.getElementById('checkout-form') as HTMLFormElement;
const pinInputs = document.querySelectorAll('input[data-index]') as NodeListOf<HTMLInputElement>;
const submitBtn = document.getElementById('submit-btn') as HTMLButtonElement;
const errorDiv = document.getElementById('error-message') as HTMLDivElement;

const showError = (message: string): void => {
  errorDiv.textContent = message;
  errorDiv.classList.remove('hidden');
};

const hideError = (): void => {
  errorDiv.classList.add('hidden');
};

const getPinValue = (): string => {
  return Array.from(pinInputs).map(input => input.value).join('');
};

const setPinValue = (pin: string): void => {
  Array.from(pinInputs).forEach((input, index) => {
    input.value = pin[index] || '';
  });
};

const validatePin = (pin: string): boolean => {
  return /^\d{6}$/.test(pin);
};

const handleSubmit = async (pin: string): Promise<void> => {
  if (!validatePin(pin)) {
    showError('PIN moet 6 cijfers bevatten');
    return;
  }

  hideError();
  pinForm.classList.add('hidden');
  loadingDiv.classList.remove('hidden');

  try {
    const data = await lookupPin(pin);
    
    setPinCookie(data.pin);
    setDeviceTypeCookie(data.deviceType);
    
    await loadCleengScript();
    initializeCleengWidget(data);
    
    loadingDiv.classList.add('hidden');
    widgetDiv.classList.remove('hidden');
  } catch (error) {
    loadingDiv.classList.add('hidden');
    pinForm.classList.remove('hidden');
    showError(error instanceof Error ? error.message : 'Er is een fout opgetreden');
  }
};

// Check for PIN in URL parameter
const urlParams = new URLSearchParams(window.location.search);
const urlPin = urlParams.get('pin');

if (urlPin) {
  setPinValue(urlPin);
  handleSubmit(urlPin);
}

// Form submission handler
form.addEventListener('submit', (e) => {
  e.preventDefault();
  const pin = getPinValue();
  handleSubmit(pin);
});

// PIN input handling
pinInputs.forEach((input, index) => {
  input.addEventListener('input', (e) => {
    const target = e.target as HTMLInputElement;
    const value = target.value.replace(/\D/g, '');
    target.value = value;
    
    // Auto-focus next input
    if (value && index < pinInputs.length - 1) {
      pinInputs[index + 1].focus();
    }
    
    // Auto-submit when last digit is entered
    if (value && index === pinInputs.length - 1) {
      const pin = getPinValue();
      if (validatePin(pin)) {
        handleSubmit(pin);
      }
    }
  });
  
  input.addEventListener('keydown', (e) => {
    // Handle backspace to focus previous input
    if (e.key === 'Backspace' && !input.value && index > 0) {
      pinInputs[index - 1].focus();
    }
  });
});